import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

import { IDisconnectAccountRequest } from "../../features/Configurations/Integration/interface";

export const useDeleteIntegration = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>({
        mutationFn: async (trackingId: string) => {
            await httpService.post<void, IDisconnectAccountRequest>(API_CONFIG.path.disconnectAccount, {
                trackingId,
            });
        },
    onSuccess: () => {
      // Invalidate and refetch integrations after successful deletion
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
